<div [class.active-icon]="active" [class.hover-icon]="hover">
  <div [ngClass]="className" class="app-icon" [style.width]="width" [style.height]="height" [style.margin]="margin"></div>
</div>
